import { Modal as AntModal } from 'antd';

export const confirmAction = (title: string, onConfirm: () => void | Promise<void>) => {
  return new Promise<void>((resolve, reject) => {
    AntModal.confirm({
      title,
      okText: 'Підтвердити',
      cancelText: 'Відмінити',
      onOk: async () => {
        try {
          await onConfirm();
          resolve();
        } catch (error) {
          // CRA error overlay stringifies non-Error rejects as "[object Object]".
          reject(
            error instanceof Error
              ? error
              : new Error(
                  typeof error === 'object' &&
                  error !== null &&
                  'message' in error &&
                  typeof (error as { message: unknown }).message === 'string'
                    ? (error as { message: string }).message
                    : 'Action failed',
                ),
          );
        }
      },
      onCancel: () => {
        reject(new Error('Action canceled by user'));
      },
    });
  });
};
